import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d72c56fe: FaireBrandEntity = {
  token: "b_d72c56fe",
  type: "brand",
  name: "54 Celsius",
  avatarUrl:
    "https://cdn.faire.com/fastly/85286f00a64c92db72aed64d3adb1ba526890534c3bbc28bd4cd2632bf76ab15.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dfc6bc849f0e21316f5f8be6290f93f5f1ef08754a444119536d89bfafc506ac.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/85286f00a64c92db72aed64d3adb1ba526890534c3bbc28bd4cd2632bf76ab15.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dfc6bc849f0e21316f5f8be6290f93f5f1ef08754a444119536d89bfafc506ac.jpeg",
  location: "Great Barrington, MA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 229,
  isTopShop: true,
  isInsider: true,
  description:
    "54Celsius is a candle and décor company based on good design and a little bit of mischief. Our goal is to spark a spontaneous reaction – be it a laugh, a thoughtful smile, or occasionally even a bit of discomfort. Why? Reactions are emotions. Emotions cement memories. And memories stick around long after the candle goes out.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:04.512Z",
    importedBy: "entity-db-cli",
  },
};
